'use strict';

const $ = window.jQuery;

function closePopin ( videoPopin ) {
    if ( videoPopin ) {
        videoPopin.stop()
        setTimeout(function() {
            videoPopin.destroy()
        }, 300)
    }

    $('.popin').removeClass('is-active').attr('aria-hidden', 'true')
    $('body').removeClass('no-scroll')
    $('.popin__content').getNiceScroll().remove()
}

function popin() {
    const $body   = $('body')
    let videoPopin = ''

    $('[data-popin]').on('click', function () {
        const popinID = $('#' + $(this).data('popin') )
        let contentHeight = 0

        $body.addClass('no-scroll')
        popinID.addClass('is-active')
        popinID.attr('aria-hidden', (i, attr) => 'true' === attr ? 'false' : 'true')

        if ( $(this).hasClass('search-deployer') ) {
            $('.search-form__input').focus()
            $('.header__useful, .nav-main-l1__item, .lang-switcher, .account-menu').removeClass('is-active')
        }

        if ( $(this).data('video') ) {
            const videoId = $(this).data('video')
            $('#popinPlayer').attr('data-plyr-embed-id', videoId)
            videoPopin = new Plyr('#popinPlayer', {
                ratio: '16:9'
            });

            videoPopin.once('ready', function() {
                videoPopin.play()
            })
        }

        $('.popin__content').children().each(function() {
            contentHeight = contentHeight + $(this).outerHeight(true)
        })

        if ( contentHeight > $('.popin__content').innerHeight() ) {
            setTimeout( function () {
                $('.popin__content').niceScroll({
                    cursorcolor: '#ffffff',
                    background: 'rgba(0, 0, 0, .1)',
                    cursorborder: '0',
                    cursorborderradius: '0',
                    cursorwidth: '5px',
                    autohidemode: false,
                    horizrailenabled: false
                })
            }, 400)
        }

        $('.popin__wrapper').niceScroll({
            cursorcolor: '#004337',
            cursorwidth: '5px',
            cursorborder: '0',
            cursorborderradius: '5px',
            horizrailenabled: false
        });
    })

    $('.popin__wrapper, .search-form__input, .popin__video-wrapper').on('click', function (e) {
        e.stopPropagation()
    })

    $(document).keyup(function (e) {
        if ( e.keyCode === 27 ) closePopin( videoPopin )
    })

    $('.popin, [data-close="true"]').on('click', function() {
        closePopin( videoPopin )
    })
}

module.exports = function () {
    popin();

    $(document).on('facetwp-refresh, facetwp-loaded', function() {
        popin();
    });
};
